import { createSelector } from 'reselect'
import { constants } from './constants'

const EMPTY_MAP = {}

export const orgId = state => state.getIn(['currentUser', 'user', 'orgId'])
export const userGates = state => state.getIn(['currentUser', 'user', 'gates'])
export const org = state => state.getIn(['org', 'data'])
export const endUserCount = state => state.getIn(['org', 'endUserCount'])
export const orgName = state => state.getIn(['org', 'data', 'name'])
export const orgHandle = state => state.getIn(['org', 'data', 'handle'])
export const status = state => state.getIn(['org', 'status', 'update'])
export const properties = state => state.getIn(['org', 'data', 'properties']) || EMPTY_MAP
export const actualProperties = state => state.getIn(['org', 'data', 'properties'])
export const getIsVidyardEnabled = state => properties(state).isVidyardEnabled
export const getOutboundInboxId = state => properties(state).outboundInboxId
export const orgCutover = (state, cutoverName) => state.getIn(['org', cutoverName])

export const hasCustomizedAssistantSFDCMapping = state =>
  _.get(properties(state), 'hasCustomizedAssistantSFDCMapping', false)
export const hasCustomizedAssistantSFDCActivity = state =>
  _.get(properties(state), 'hasCustomizedAssistantSFDCActivity', false)

export const getDateCreatedAt = state => state.getIn(['org', 'data', 'createdAt'])

export const orgLogoUrl = state => {
  if (!!state.getIn(['org', 'data', 'properties']))
    return state.getIn(['org', 'data', 'properties'])['org-logo-url']
  return null
}

export const arePropertiesLoaded = createSelector(
  state => state.getIn(['org', 'data', 'properties']),
  properties => !!properties
)

export const isLoaded = createSelector(
  state => state.getIn(['org', 'status', 'fetch']),
  orgFetchStatus => orgFetchStatus === constants.RECEIVE_ORG
)

export const hasAutoCreatedOBPB = createSelector(
  orgId,
  orgId => orgId >= 1066286) // this is the first orgId after the backend code was merged

export const hasLimitedContactsMktEmail = state =>
  state && state.getIn(['org', 'hasLimitedContactsMktEmail'])



// WEBPACK FOOTER //
// ./src/scripts/app/modules/org/selectors.js